import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import { FormBuilder, Validators,FormArray,FormControl,FormsModule } from '@angular/forms';
import {Title} from '@angular/platform-browser';
import { EventService } from '../../event.service';

@Component({
  selector: 'app-category-pop-up',
  templateUrl: './category-pop-up.component.html',
  styleUrls: ['./category-pop-up.component.css','../../admin.css', '../../../app.component.css'],
  providers: [ EventService ]
})
export class CategoryPopUpComponent implements OnInit {
  catId:any;
  catName:any;
  catType:any;
  catForm:any;
  errorMessage : any;
  spinner: boolean = false;

  constructor(private pageTitle: Title,private router: Router, public dialogRef: MdDialogRef<CategoryPopUpComponent>, private formBuilder: FormBuilder, private eventService: EventService,private snackBar: MdSnackBar) {
    this.catForm = this.formBuilder.group({
      'catName': ['', Validators.required],
      'catType': ['', Validators.required],
      'catId':'',
    });
  }

  ngOnInit() {
    if(this.catName) {
      this.catForm.controls['catId'].patchValue(this.catId);
      this.catForm.controls['catType'].patchValue(this.catType);
      this.catForm.controls['catName'].patchValue(this.catName);
    }
  }

  catAdd() {
    if (this.catForm.dirty) {
      if (this.catForm.valid ) {
        this.spinner = true;
        this.eventService.categoryAdd(this.catForm.value)
            .subscribe(
                response => {
                  this.spinner = false;
                  if(response.status)
                  {
                    this.snackBar.open(response.message,'',{duration:4000});
                    this.dialogRef.close(response.status);
                  }
                  else{
                    this.spinner = false;
                    this.snackBar.open(response.message,'',{duration:4000});
                  }
            },
                error => {
              this.spinner = false;
              this.errorMessage = <any>error;
            }
        );
      }
    } else {
      // this.dialogRef.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/categories/category-pop-up/category-pop-up.component.ts